import React from 'react';
import CallToActionContext from '../CallToActionContext';

export default function CallToActionProvider(props) {
  const { children } = props;
  return <CallToActionContext.Provider>{children}</CallToActionContext.Provider>;
}
